import React from 'react';
import { Poppins } from 'src/common/Poppins';
import Input from 'src/components/form/Input';
import styled from 'styled-components';

const Div = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  .events-only-switch {
    display: flex;
    align-items: center;
    gap: 10px;
    user-select: none;
    cursor: pointer;
  }
`;

interface ToolBarProps {
  showAudit: boolean;
  setShowAudit: (showAudit: boolean) => void;
}

export const ToolBar: React.FC<ToolBarProps> = ({ showAudit, setShowAudit }) => {
  return (
    <Div>
      <div />
      <div className="events-only-switch" onClick={() => setShowAudit(!showAudit)} data-cy="audit:show-audit">
        <Poppins px={14} color="cflowerBlue">
          Show audit
        </Poppins>
        <Input checked={showAudit} className="switch" type="checkbox" />
      </div>
    </Div>
  );
};
